"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteQuery = void 0;
const core_ui_1 = require("@sierralabs/core-ui");
function useDeleteQuery(id) {
    const { data, isLoading, error, del } = (0, core_ui_1.useApiDelete)(`queries/${id}`);
    return {
        deletedQuery: data,
        deletingQuery: isLoading,
        deleteError: error,
        deleteQuery: del
    };
}
exports.useDeleteQuery = useDeleteQuery;
//# sourceMappingURL=useDeleteQuery.js.map